import { CheckInData, EditLeavePayload, ICreateHoliday, ICreateHrPayrollSnapshot, IEditHolidayPayload, IEditRegularization, IGetHrPayroll, IGetHrPayrollSnapshot, IGetReport, IHolidayListSearch, IHrAttendanceListSearch, IHrMyAttendanceListSearch, IMyRegularizationListSearch, IUpdateSnapshotPayload, IUpdateSnapshotStatus, LeaveListSearch, MyLeaveListSearch } from "../../../../types/hr/hrInterface";
import { ApplyLeavePayload, IApplyRegularization } from "../../../../types/userInterface";
import api from "../../../../lib/api";


export const getHrAttendanceListApi = async (data: IHrAttendanceListSearch) => {
  return await api.get(`hr-attendance/daily-attendance-log/${data.page}/${data.pageLimit}?date=${data?.date ?? ""}&search=${data?.search ?? ""}`);
};

export const getMyAttendanceListApi = async (data: IHrMyAttendanceListSearch) => {
  return await api.get(`hr-attendance/my-attendance/${data.page}/${data.pageLimit}`, {
    params: {
      status: data.status,
      from_date: data.fromDate,
      to_date: data.toDate,
    }
  });
};

export const getMyRegularizationListApi = async (data: IMyRegularizationListSearch) => {
  return await api.get(`hr-regularization/my-regularization/${data.page}/${data.pageLimit}`, {
    params: {
      status: data.status,
      from_date: data.fromDate,
      to_date: data.toDate,
    }
  });
};

export const getRegularizationListApi = async (data: IMyRegularizationListSearch) => {
  return await api.get(`hr-regularization/${data.page}/${data.pageLimit}`, {
    params: {
      status: data.status,
      from_date: data.fromDate,
      to_date: data.toDate,
    }
  });
};

export const getAttendanceReportApi = async (data: IGetReport) => {
  return await api.post(`hr-attendance/attendance-report`, data,{
    responseType:  "blob"
  })
}

export const userCheckinApi = async (data: CheckInData) => {
  return await api.post(`/hr-attendance/check-in`, data)
}

export const userCheckOutApi = async (data: CheckInData) => {
  return await api.post(`/hr-attendance/check-out`, data)
}

export const getActivityApi = async (data: {date?: string}) => {
  return await api.get(`/hr-attendance/get-activity`, {
    params: {
      date: data?.date ?? ""
    }
  })
}

export const getLeaveListApi = async (payload: LeaveListSearch) => {
  return await api.get(`hr-leaves/${payload.page}/${payload.pageLimit}`, {
    params: {
      search: payload?.search ?? "",
      from_date: payload.fromDate,
      to_date: payload.toDate,
      branch_id: payload?.branchId ?? 0,
      status: payload?.status
    }
  });
};

export const getLeaveDataByIdApi = async (leaveId: string) => {
  return await api.get(`/hr-leaves/${leaveId}`)
}

export const editLeaveApi = async (payload: EditLeavePayload) => {
  return await api.put(`/hr-leaves/${payload.id}`, payload.data)
}

export const applyLeaveApplicationApi = async (data: ApplyLeavePayload) => {
  return await api.post(`/hr-leaves`, data)
}

export const getMyLeaveListApi = async (payload: MyLeaveListSearch) => {
  return await api.get(`/hr-leaves/applied/${payload.page}/${payload.pageLimit}`);
};

export const applyRegularizationApi = async (data: IApplyRegularization) => {
  return await api.post(`/hr-regularization`, data)
}

export const updateRegularizationStatusApi = (data: { regularization_id: number[], status: "APPROVED" | "DECLINED" }) => {
  return api.put("/hr-regularization/update-status", data)
}

export const getRegularizationByIdApi = async (id: string) => {
  return await api.get(`/hr-regularization/${id}`)
}

export const editRegularizationApi = async (payload: IEditRegularization) => {
  return await api.put(`/hr-regularization/${payload.id}`, payload.data)
}

export const getHolidayListApi = async (payload: IHolidayListSearch) => {
  return await api.get(`hr-holidays/${payload.page}/${payload.pageLimit}`, {
    params: {
      search: payload?.search ?? "",
    }
  });
};

export const createHolidayApi = async (payload: ICreateHoliday) => {
  return await api.post(`hr-holidays`, payload);
};

export const getHolidayByIdApi = async (id: string) => {
  return await api.get(`hr-holidays/${id}`);
};

export const editHolidayByIdApi = async (payload: IEditHolidayPayload) => {
  return await api.put(`/hr-holidays/${payload.id}`, payload.data)
}


export const getHrPayrollApi = async (data: IGetHrPayroll) => {
  return await api.get(`hr-payroll`, {
    params: {
      payroll_group_id: data.pay_group_id,
      // from_date: data.fromDate,
      // to_date: data.toDate,
    }
  });
};

export const getHrPayrollSnapshotDetailApi = async (data: { payroll_id: number }) => {
  return await api.get(`hr-payroll-snapshot/details`, {
    params: {
      payroll_id: data.payroll_id,
    }
  });
};

export const getHrPayrollSnapshotListApi = async (data: IGetHrPayrollSnapshot) => {
  return await api.get(`hr-payroll-snapshot/${data.page}/${data.pageLimit}`, {
    params: {
      payroll_id: data.payroll_id,
      status: data.status,
      search: data.search?.length ? data.search : undefined,
      user_id: data?.user_id ?? undefined
    }
  })
}

export const createHrPayrollSnapshotApi = async (data: ICreateHrPayrollSnapshot) => {
  return await api.post("hr-payroll-snapshot", data)
}

export const updateHrPayrollSnapshotApi = async ({ id, data }: IUpdateSnapshotPayload) => {
  return await api.put(`hr-payroll-snapshot/${id}`, data)
}

export const updateHrPayrollSnapshotPayslipStatusApi = async (data: IUpdateSnapshotStatus) => {
  return await api.put(`hr-payroll-snapshot/update-payslip-status`, data)
}

export const getHrPayrollSnapshotByIdApi = async (id: number) => {
  return await api.get(`hr-payroll-snapshot/${id}`)
}

export const runHrPayrollByIdApi = (id: number) => {
  return api.put(`hr-payroll-snapshot/run-payroll/${id}`);
}

export const updateHrPayrollSnapshotStatusApi = (data: { snapshot_id: number[], status: "APPROVED" | "HOLD" }) => {
  return api.put("/hr-payroll-snapshot/update-status", data)
}

export const downloadHrPayrollSlipApi = (data: { payroll_id: number; user_id: number, is_payslip_released: boolean }) => {
  return api.get(`/hr-payroll-snapshot/download/user-pay-slip`, {
    responseType: data.is_payslip_released ? "blob" : "json",
    params: {
      payroll_id: data.payroll_id,
      user_id: data.user_id,
    },
  });
};

export const downloadPayslipApi = ({released, ...payload}: { snapshot_id?: number[]; payroll_id: number; released: boolean }) => {
  return api.post(`/hr-payroll-snapshot/download/pay-slips`, payload, {
    responseType: released ? "blob" : "json"
  });
}

export const releasePayslipApi = (payload: { snapshot_id?: number[]; payroll_id: number; }) => {
  return api.put(`/hr-payroll-snapshot/release-payslips`, payload);
}